import { $$ } from "./util.js";

export function initFaq() {
  $$(".faq-q").forEach((q) => {
    const a = q.nextElementSibling;
    if (!a) return;
    q.addEventListener("click", () => {
      const open = q.getAttribute("aria-expanded") === "true";
      q.setAttribute("aria-expanded", String(!open));
      a.hidden = open;
    });
  });
}
